import { render, staticRenderFns } from "./RolesOptions.vue?vue&type=template&id=0de76d24&"
import script from "./RolesOptions.vue?vue&type=script&lang=js&"
export * from "./RolesOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports